import { Box } from "@chakra-ui/react"
import { overlayStyles } from "./DotBackground"

type ResourceBackgroundProps = {
  resource: any
  className?: string
  style?: any
  children?: any
  overlay?: string
  forceBlur?: boolean
}

const ResourceBackground = ({ resource, overlay, forceBlur }: ResourceBackgroundProps) => {
  // Derive the background image from the resource prop
  const image =
    resource.background_type === 5
      ? resource.background_image_blurred_cdn || resource.blurred_background
      : resource.background_image

  return (
    <>
      <Box
        {...overlayStyles}
        backgroundImage={`url(${image})`}
        backgroundSize="cover"
        backgroundPosition="center"
        filter={resource.background_type === 5 || forceBlur ? "blur(30px)" : undefined}
      />
      {overlay && (
        <Box
          {...overlayStyles}
          bgGradient="linear(to-b, rgba(51, 49, 50, 0.5) 0%, rgba(51, 49, 50, 1) 100%)"
        />
      )}
    </>
  )
}

ResourceBackground.displayName = "ResourceBackground"

export default ResourceBackground
